import { DxpStaticSettingsConfigService } from './static-settings-config.service';
import { Injectable } from '@angular/core';
import {
  I18nService,
  LuigiCoreService,
  LuigiNode,
  NodeChangeHookConfigService,
} from '@openmfp/portal-ui-lib';

@Injectable({ providedIn: 'root' })
export class DxpNodeChangeHookConfigService
  implements NodeChangeHookConfigService
{
  constructor(
    private i18nService: I18nService,
    private luigiCoreService: LuigiCoreService,
    private staticSettingsConfigService: DxpStaticSettingsConfigService,
  ) {}

  async nodeChangeHook(_: unknown, nextNode: any): Promise<void> {
    if (this.handlePathReplacementRedirect(nextNode)) {
      return;
    }

    const ctx = this.luigiCoreService.getGlobalContext();
    ctx.helpContext = nextNode.helpContext;

    const entityTitle = nextNode.ignoreInDocumentTitle
      ? undefined
      : nextNode.label;

    const appTitle = (
      await this.staticSettingsConfigService.getStaticSettingsConfig()
    ).header.title;
    const interpunct = '·';

    let rootNode = nextNode;
    while (rootNode.parent) {
      rootNode = rootNode.parent;
    }

    let title: string;
    if (rootNode.pathSegment === 'search') {
      const searchTitle = this.i18nService.getTranslation(
        'SEARCH_LABEL_IN_DOC_TITLE',
      );
      const query = this.luigiCoreService.routing().getSearchParams().q;
      title = query ? `${searchTitle}: ${query} ${interpunct} ` : '';
      title += `${searchTitle} (${entityTitle}) | ${appTitle}`;
    } else {
      title = rootNode.label + ' | ' + appTitle;
    }

    this.luigiCoreService.ux().setDocumentTitle(title);
  }

  // Checks if the node or any of its parents have path replacement context
  // If found, performs the path replacement and navigates to the new URL
  // This is used for redirecting old /projects/ paths to new /workspaces/ paths
  private handlePathReplacementRedirect(node: LuigiNode): boolean {
    const redirectNode = this.findRedirectNode(node);
    if (redirectNode) {
      const newUrl = `${globalThis.location.pathname.replace(
        redirectNode.context?.pathToReplace,
        redirectNode.context?.targetPath,
      )}${globalThis.location.search || ''}`;
      if (
        globalThis.location.pathname.includes(
          redirectNode.context?.pathToReplace,
        )
      ) {
        this.luigiCoreService.navigation().navigate(newUrl);
        return true;
      }
    }
    return false;
  }

  private findRedirectNode(node: LuigiNode | undefined): LuigiNode | undefined {
    while (node) {
      if (
        node.context?.pathToReplace !== undefined &&
        node.context?.targetPath !== undefined
      ) {
        return node;
      }
      node = node.parent;
    }
    return undefined;
  }
}
